'use strict';

import axios from 'axios';
import getHeader from '../config/header';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Addresses = {

	async createNew(address1, city, state, postalCode, country, address2 = null) {
		try {
			if (!address1 || !city || !country) {
				return { error: 'At least one field is missing' };
			}

            let response = await axios.post(API_URL + '/address', {
				"address1": address1,
				"address2": !address2 ? null : address2,
				"city": city,
				"state": !state ? null : state,
				"postalCode": !postalCode ? null : postalCode,
				"country": country
			}, await getHeader());

			return !response.data.id ? false : response.data.id;
			
		} catch(error) {
            return false;
		}
	},

	async update(addressID, address1, city, state, postalCode, country, address2 = null) {
		try {
			if (!addressID || !address1 || !city || !country) {
				return { error: 'At least one field is missing' };
			}

            let response = await axios.patch(API_URL + '/address/' + addressID, {
				"address1": address1,
				"address2": !address2 ? null : address2,
				"city": city,
				"state": !state ? null : state,
				"postalCode": !postalCode ? null : postalCode,
				"country": country
			}, await getHeader());

			return !response.data.id ? false : response.data.id;

		} catch(error) {
            return false;
		}
	}

}

export default Addresses;
